import { ContentEventItem } from '@app/api/models/ContentEvent/ContentEventModels';
import BoardContentEventApi from '@app/api/public/BoardContentEventApi';
import { useMutation, useQueryClient } from 'react-query';
import { memberEventQueryKeys } from './boardEventQueries';

type Variables = { id: ContentEventItem['id'] };

const useRemoveEvent = () => {
    const client = useQueryClient();
    return useMutation(
        (varables: Variables) => {
            return BoardContentEventApi.remove(varables.id);
        },
        {
            onSettled: () => {
                client.invalidateQueries(memberEventQueryKeys.all);
            },
        }
    );
};

export default useRemoveEvent;
